"use strict";
var gpml_utilities_1 = require("./gpml-utilities");
exports.wpTypes2BiopaxTypes = {
    'Complex': 'Complex',
    // TODO which one of the following two should we use?
    'GeneProduct': 'Dna',
    //'GeneProduct': ['Dna', 'Rna', 'Protein'],
    'Metabolite': 'SmallMolecule',
    'Pathway': 'Pathway',
    'Protein': 'Protein',
    'Rna': 'Rna',
    'Unknown': 'PhysicalEntity',
    // Non-standard Types
    'GeneProdKegg enzymeuct': 'Protein',
    'SimplePhysicalEntity': 'PhysicalEntity',
    'Modifier': 'SmallMolecule',
    'State': 'SmallMolecule',
};
exports.DATA_NODE_DEFAULTS = {
    attributes: {
        Align: {
            name: 'Align',
            value: 'Center'
        },
        Color: {
            name: 'Color',
            value: '000000'
        },
        FontSize: {
            name: 'FontSize',
            value: 10
        },
        LineThickness: {
            name: 'LineThickness',
            value: 1
        },
        Padding: {
            name: 'Padding',
            value: '0.1em'
        },
        ShapeType: {
            name: 'ShapeType',
            value: 'Rectangle'
        },
        Valign: {
            name: 'Valign',
            value: 'Top'
        },
        ZOrder: {
            name: 'ZOrder',
            value: 0
        },
    }
};
function applyDefaults(gpmlElement, defaults) {
    gpmlElement.attributes.Type = gpmlElement.attributes.Type || { value: 'Unknown' };
    return gpml_utilities_1.applyDefaults(gpmlElement, [exports.DATA_NODE_DEFAULTS, defaults]);
}
exports.applyDefaults = applyDefaults;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1ub2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2RhdGEtbm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsbURBQWdGO0FBRW5FLFFBQUEsbUJBQW1CLEdBQUc7SUFDakMsU0FBUyxFQUFFLFNBQVM7SUFDckIscURBQXFEO0lBQ3BELGFBQWEsRUFBRSxLQUFLO0lBQ3BCLDJDQUEyQztJQUMzQyxZQUFZLEVBQUUsZUFBZTtJQUM3QixTQUFTLEVBQUUsU0FBUztJQUNwQixTQUFTLEVBQUUsU0FBUztJQUNwQixLQUFLLEVBQUUsS0FBSztJQUNaLFNBQVMsRUFBRSxnQkFBZ0I7SUFDM0IscUJBQXFCO0lBQ3JCLHdCQUF3QixFQUFFLFNBQVM7SUFDbkMsc0JBQXNCLEVBQUUsZ0JBQWdCO0lBQ3hDLFVBQVUsRUFBRSxlQUFlO0lBQzNCLE9BQU8sRUFBRSxlQUFlO0NBQ3pCLENBQUM7QUFFUyxRQUFBLGtCQUFrQixHQUFHO0lBQy9CLFVBQVUsRUFBRTtRQUNYLEtBQUssRUFBRTtZQUNOLElBQUksRUFBRSxPQUFPO1lBQ2IsS0FBSyxFQUFFLFFBQVE7U0FDZjtRQUNELEtBQUssRUFBRTtZQUNOLElBQUksRUFBRSxPQUFPO1lBQ2IsS0FBSyxFQUFFLFFBQVE7U0FDZjtRQUNELFFBQVEsRUFBRTtZQUNULElBQUksRUFBQyxVQUFVO1lBQ2YsS0FBSyxFQUFDLEVBQUU7U0FDUjtRQUNELGFBQWEsRUFBRTtZQUNkLElBQUksRUFBRSxlQUFlO1lBQ3JCLEtBQUssRUFBRSxDQUFDO1NBQ1I7UUFDRCxPQUFPLEVBQUU7WUFDUixJQUFJLEVBQUUsU0FBUztZQUNmLEtBQUssRUFBRSxPQUFPO1NBQ2Q7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsV0FBVztZQUNqQixLQUFLLEVBQUUsV0FBVztTQUNsQjtRQUNELE1BQU0sRUFBRTtZQUNQLElBQUksRUFBRSxRQUFRO1lBQ2QsS0FBSyxFQUFFLEtBQUs7U0FDWjtRQUNELE1BQU0sRUFBRTtZQUNQLElBQUksRUFBRSxRQUFRO1lBQ2QsS0FBSyxFQUFFLENBQUM7U0FDUjtLQUNEO0NBQ0QsQ0FBQztBQUVGLHVCQUE4QixXQUFXLEVBQUUsUUFBUTtJQUNsRCxXQUFXLENBQUMsVUFBVSxDQUFDLElBQUksR0FBRyxXQUFXLENBQUMsVUFBVSxDQUFDLElBQUksSUFBSSxFQUFDLEtBQUssRUFBRSxTQUFTLEVBQUMsQ0FBQztJQUNoRixNQUFNLENBQUMsOEJBQWlCLENBQUMsV0FBVyxFQUFFLENBQUMsMEJBQWtCLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQztBQUN2RSxDQUFDO0FBSEQsc0NBR0M7QUFBQSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/data-node.js
// module id = 129
// module chunks = 0